<template>
    <v-layout row>
        <v-dialog v-model="dialog" persistent max-width="800px">
            <v-btn
                    icon
                    flat
                    v-if="tieneFeedback"
                    slot="activator"
                    color="green"
            >
                <v-icon>announcement</v-icon>
            </v-btn>
            <v-btn
                    flat
                    v-if="! tieneFeedback"
                    slot="activator"
                    bicon
                    color="red"
            >
                <v-icon class="text--primary" left>announcement</v-icon>
            </v-btn>
            <v-card v-if="! tieneFeedback">
                <form v-on:submit.prevent="create">
                    <v-card-title>
                        <span class="headline">Feedback for sample: {{ sample_order_line.name }} ({{ sample_order_line.lc_code }})</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12 s12 md12>
                                    <v-textarea
                                            v-validate="'required'"
                                            :error-messages="errors.collect('data.feedback')"
                                            box
                                            name="input-7-4"
                                            label="Feedback"
                                            v-model="data.feedback"
                                            data-vv-name="data.feedback"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                        <v-btn color="blue darken-1" flat type="submit">Save</v-btn>
                    </v-card-actions>
                </form>
            </v-card>
            <v-card v-if="tieneFeedback">
                <v-card-title>
                    <span class="headline">Feedback for sample: {{ sample_order_line.name }} ({{ sample_order_line.lc_code }})</span>
                </v-card-title>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex xs12 s12 md12>
                                <p>{{ data.feedback }}</p>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click.native="cancel()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
    export default {
        props: ['sample_order_id', 'sample_order_line'],
        data: () => ({
            dialog: false,
            data : {
                feedback: '',
                sample_order_id: null,
                sample_order_line_id: null
            },
            tieneFeedback: false
        }),
        created () {
            this.getFeedback();
        },
        methods: {
            getFeedback () {
                this.data.sample_order_id = this.sample_order_id;
                this.data.sample_order_line_id = this.sample_order_line.id;
                 this.$store.dispatch('getSampleOrderLineFeedback', this.data).then((res) => {
                    this.data.feedback = res.data.data.feedback;
                    this.tieneFeedback = true;
                }).catch((error) => {

                });
            },
            create () {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.data.sample_order_id = this.sample_order_id;
                        this.data.sample_order_line_id = this.sample_order_line.id;
                        this.$store.dispatch('createSampleOrderLineFeedback', this.data).then((res) => {
                            this.tieneFeedback = true;
                            this.dialog = false
                        }).catch((error) => {

                        });
                    }
                });
            },
            cancel () {
                this.dialog = false;
                this.data = this.data = {
                    feedback: '',
                    sample_order_id: null,
                    sample_order_line_id: null
                };
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/samples/views/components/FeedbackComponent.vue